/* eslint-disable */
import { assetImages } from "constants";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

const PostSuccessModal = ({ onModalClose }) => {
  return (
    <div className="conatct_modal success_popup">
      <div
        className="modal fade"
        id="success_mdl"
        data-bs-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body py-4 px-4">
              <div className="success_graphics text-center mb-3">
                <img src={assetImages.submitTickSvg} alt="" />
              </div>
              <div className="success_text text-center">
                <h3>Congratulations!</h3>
                <p className="text-primary-gray mt-3 fs-sm fw-medium">
                  Post is saved successfully
                </p>
                <div className="btns_group d-flex align-items-center justify-content-center gap-2 mt-3">
                  <Link
                    to="#"
                    data-bs-dismiss="modal"
                    className="btn"
                    onClick={() => {
                      onModalClose();
                    }}
                  >
                    Close
                  </Link>
                  {/* <Link
                    to="#"
                    data-bs-dismiss="modal"
                    data-bs-target="#login_modal"
                    data-bs-toggle="modal"
                    className="btn primary-btn"
                  >
                    Let’s Begin
                  </Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostSuccessModal;
